
import { useTranslation } from 'react-i18next';

export default function BenefitsSection() {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      titleKey: 'rich_income',
      descKey: 'rich_income_desc',
      color: 'from-green-500 to-emerald-600'
    },
    {
      icon: 'ri-global-line',
      titleKey: 'global_brands',
      descKey: 'global_brands_desc',
      color: 'from-blue-500 to-cyan-600'
    },
    {
      icon: 'ri-team-line',
      titleKey: 'professional_support',
      descKey: 'professional_support_desc',
      color: 'from-purple-500 to-violet-600'
    },
    {
      icon: 'ri-trophy-line',
      titleKey: 'growth_opportunities',
      descKey: 'growth_opportunities_desc',
      color: 'from-orange-500 to-red-600'
    },
    {
      icon: 'ri-shield-check-line',
      titleKey: 'contract_protection',
      descKey: 'contract_protection_desc',
      color: 'from-indigo-500 to-purple-600'
    },
    {
      icon: 'ri-data-line',
      titleKey: 'data_insights',
      descKey: 'data_insights_desc',
      color: 'from-pink-500 to-rose-600'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('benefits_title')}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-600 to-pink-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('benefits_desc')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-r ${benefit.color} flex items-center justify-center mb-6`}>
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {t(benefit.titleKey)}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {t(benefit.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
